import * as React from 'react';
import { useSelector } from 'react-redux';
import { getOperationSafe } from 'selectors';
import { IState } from 'services/root-reducer';
import { SlideUpPanel } from 'mobile-ui/components/slideup-panel';
import { actions as overlayWindowsActions } from 'services/overlay-windows/overlay-windows-service';
import { DataUpdateForm } from 'scenes/overlay-data-update/data-update-form';

export const MobileUIObjectDataUpdate = () => {
    let dataUpdateFormOperation = useSelector(
        (state: IState) => getOperationSafe(state, 'UPDATE_DATA_OVERLAY')
    );

    if (!dataUpdateFormOperation.data?.visible) {
        return null;
    }

    return (
        <SlideUpPanel
            open
            className='mobile-ui-data-update-form fix-close-button'
        >
            <DataUpdateForm
                onSubmit={(payload) => {
                    overlayWindowsActions.submitDataUpdateForm(payload);
                }}
            />
        </SlideUpPanel>
    );
};
